import { render, staticRenderFns } from "./listOperadoras.vue?vue&type=template&id=6f79a2dc"
import script from "./listOperadoras.ts?vue&type=script&lang=js&external"
export * from "./listOperadoras.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f79a2dc')) {
      api.createRecord('6f79a2dc', component.options)
    } else {
      api.reload('6f79a2dc', component.options)
    }
    module.hot.accept("./listOperadoras.vue?vue&type=template&id=6f79a2dc", function () {
      api.rerender('6f79a2dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/contareceber/listOperadoras.vue"
export default component.exports